export const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
export const snap = (v, g) => (g ? Math.round(v / g) * g : v);
export const MINIMIZED_SIZE = 64;

const KEY = "chartPanel";

export function loadChartSession() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function saveChartSession(partial) {
  try {
    const prev = loadChartSession();
    sessionStorage.setItem(KEY, JSON.stringify({ ...prev, ...partial }));
  } catch {}
}
